import { createSelector } from '@reduxjs/toolkit';
import { selfMsgSelector } from './self';

const msgSelector = createSelector(selfMsgSelector, (messages) => messages.message);

export default msgSelector;
